import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';

import useTable from '../useTable';
 
import { formatMoneda } from '../../util/varios';
import axios from "axios";
import moment from 'moment';


const ModalAgregarEgresoEnviarCatalogo = props => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    // const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({
        idchequeemitido: ''
    });
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const headCells = [
        { label: 'Código', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'N° Egreso', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'Beneficiario', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'Cuenta', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'Monto', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'Fec. de Emision', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
    ]
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idchequeemitido.includes(target.value)
                            || x.concheque.toLowerCase().includes(target.value.toLowerCase())
                            || x.proveedor.toLowerCase().includes(target.value.toLowerCase())
                            || x.observacion.toLowerCase().includes(target.value.toLowerCase())
                        ) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {
        let endpoint = `${op.conexion}/api/administracion/selectoregresosapro?idefi=${idefiscal}&ubic=${46}`;
        setActivate(true);
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status === 200) {
                setRecords(response.data)
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(() => {
            setActivate(false);
        })
    }
    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setValues({
            idmoneda: '',
            descripcion: '',
            simbolo: '',
            predeterminada: false,
            valormoneda: ''
        });
        setFilterFn({ fn: items => { return items; } });
    }
    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }
    const seleccionarMoneda = () => {
        props.onHideAceptaCatalogo(values);
    };
    const seleccionarFila = (item) => (e) => {
        e.preventDefault();
        setValues(item);
        btnAcepta.current.focus();
    };
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                seleccionarRegistros();
            }}
        >
            <Modal.Header className='bg-primary px-4 py-2'>
                <h3 className='fs-2 fw-bold m-0'>
                    Agregar Egresos.
                </h3>
                <button ref={btnCancela} 
                    className="btn btn-sm bg-light" 
                    onClick={cancelar}>
                    <i className="fa fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-12 m-0 p-0">
                    <div className="col-6 input-group input-group-sm mb-3">
                        <input type='text'
                            onChange={handleSearch} className="form-control rounded-pill search-input" />
                    </div>
                </div>
                <div style={{height:'300px'}} className="overflow-auto col-12 m-0 p-0">
                    <TblContainer >
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: values.idchequeemitido === item.idchequeemitido ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                                        <td className='py-2 text-center'>{item.idchequeemitido}</td>
                                        <td className='py-2 text-center'>{item.numerocheque}</td>
                                        <td className='py-2 text-center'>{item.portador}</td>
                                        <td className='py-2 text-center'>{item.nombre}</td>
                                        <td className='py-2 text-center'>{formatMoneda(item.montocheque.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td className='py-2 text-center'>{moment.utc(item.fehcaemi).format('DD/MM/YYYY')}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </TblContainer>
                    <TblPagination />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded" style={{ margin: "5px" }} onClick={seleccionarMoneda}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalAgregarEgresoEnviarCatalogo;